import { render, staticRenderFns } from "./ToCnki.vue?vue&type=template&id=3521625c&scoped=true&"
import script from "./ToCnki.vue?vue&type=script&lang=js&"
export * from "./ToCnki.vue?vue&type=script&lang=js&"
import style0 from "./ToCnki.vue?vue&type=style&index=0&id=3521625c&prod&lang=scss&"
import style1 from "./ToCnki.vue?vue&type=style&index=1&id=3521625c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521625c",
  null
  
)

export default component.exports